import { canonicalizeLocale } from '../../locale/normalize'
import { getRegionalLocale } from '../../locale/regional'
import { bot, browser, defaultLocale, group, path, source, stored } from '../../locale/sources'

export default function createLocalePolicy({ platform, configuredLocales = [] } = {}) {
  const extended = configuredLocales.includes('uz-Cyrl')
  const explicit = group('explicit', [stored(), path()], (context) => Boolean(context.urlLocale))
  // Olymp Latam and the fallback policy retain the common regional rules.
  const regionalRules =
    platform === 'olymp'
      ? {
          localesByRegion: { AR: 'es', CO: 'es', RU: 'ru', BD: 'bn', IN: 'hi', TR: 'tr' },
          browserFallbackLocales: { KZ: 'kk', KG: 'ky', AZ: 'az' },
        }
      : { localesByRegion: { TR: 'tr', AZ: 'az', BD: 'bn', IN: 'hi', AR: 'es', CO: 'es' } }
  const regional = source('regional', (context) => getRegionalLocale(context, regionalRules))
  return {
    storage: {
      key: 'u_lang',
      deserialize: canonicalizeLocale,
      serialize: canonicalizeLocale,
    },
    bootstrapPriority: [explicit, bot(), stored(), browser(), defaultLocale()],
    localePriority: [explicit, bot(), stored(), regional, browser(), defaultLocale()],
    persistence: {
      bootstrapPath: 'when-missing',
      explicitPath: false,
      mirror: extended,
      i18n: extended,
    },
    profile: { overwrite: extended },
    consumers: {
      i18n: extended ? 'resolved' : 'profile-first',
      apollo: extended ? 'resolved' : 'profile-first',
      rest: extended ? 'resolved' : 'profile-first',
    },
  }
}
